module.exports = __webpack_public_path__ + "img/1-02.d51cd191.jpg";